import { FlexRowCenterHorizontal, LoadingSpinner } from '@main/core-ui';
import PendingRequests from '@main/privacy-center/src/containers/PendingRequests';
import React from 'react';
import { useIntl } from 'react-intl';

import { requestHistoryPreviewMessages } from './messages';
import { useRequestHistoryData } from './useRequestHistory';
import { RequestHistoryPreviewWrapper } from './wrappers';

/**
 * Display the preview of all requests the data subject has made
 */
export const RequestHistoryPreview: React.FC = () => {
  const { formatMessage } = useIntl();
  const {
    fetchMore,
    loading,
    showAllRequests,
    dataSubjectActiveCount,
    activeRequests,
    setShowAllRequests,
  } = useRequestHistoryData();

  // Loading
  if (activeRequests.length === 0 && loading) {
    return (
      <FlexRowCenterHorizontal>
        <LoadingSpinner />
      </FlexRowCenterHorizontal>
    );
  }
  return (
    <RequestHistoryPreviewWrapper>
      <PendingRequests
        loading={loading}
        requests={activeRequests}
        activeNotificationCount={dataSubjectActiveCount}
        showAll={showAllRequests}
        setShowAll={setShowAllRequests}
        fetchMore={fetchMore}
        preview={formatMessage(requestHistoryPreviewMessages.preview, {
          count: dataSubjectActiveCount,
        })}
      />
    </RequestHistoryPreviewWrapper>
  );
};

export default RequestHistoryPreview;
